import * as v from 'valibot';
import Ajax from '../util/ajax';
import { deviceAdded } from '../features/devices/devicesSlice';
import { hideDialog } from '../reducers/app';
import { transmitterSchema } from '../types/transmitter';
import { toNexaTransmitterKind } from '../types/device';
export function createTransmitter() {
    return (dispatch, getState) => {
        const { edit_transmitter_dialog } = getState();
        const ajax = new Ajax(dispatch);
        const url = '/transmitter/create';
        const obj = Object.assign({}, edit_transmitter_dialog);
        ajax.post(url, obj, data => {
            const res = v.safeParse(transmitterSchema, data);
            if (res.success) {
                const transmitter = res.output;
                switch (transmitter.kind) {
                    case 'onoff':
                    case 'dim':
                        {
                            const device = {
                                id: transmitter.id,
                                title: transmitter.title,
                                comment: transmitter.comment,
                                protocol: {
                                    name: 'nexa transmitter',
                                    kind: toNexaTransmitterKind(transmitter.kind),
                                    code: transmitter.code,
                                    unit: transmitter.unit,
                                }
                            };
                            dispatch(deviceAdded(device));
                        }
                        break;
                    case 'rollershade':
                        {
                            const device = {
                                id: transmitter.id,
                                title: transmitter.title,
                                comment: transmitter.comment,
                                protocol: {
                                    name: 'hasta transmitter',
                                    code: transmitter.code,
                                    unit: transmitter.unit,
                                }
                            };
                            dispatch(deviceAdded(device));
                        }
                        break;
                }
            }
            else {
                console.error(v.summarize(res.issues));
            }
            dispatch(hideDialog());
        });
    };
}
